import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { Address } from "src/app/core/model/v2/practice/address";
import { CommonService } from "src/app/core/services/v2/common.service";
import { StaffService } from "src/app/core/services/v2/staff.service";
import { HealthSystemSetup } from "../../../../core/model/v2/practice/HealthSystemSetup";
import { StaffDetails } from "../../../../core/model/v2/practice/staffDetails";
import { UserSetup } from "../../../../core/model/v2/practitioner/UserSetup";
import { PracticeService } from "../../../../core/services/v2/practice.service";
import { MyErrorStateMatcher } from "../../../../shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component";
import { SetupService } from "../../setup.service";

@Component({
  selector: "app-staff",
  templateUrl: "./staff.component.html",
  styleUrls: ["./staff.component.scss"],
})
export class StaffComponent implements OnInit {
  @Input() open = false;
  @Input() availableHealthSystems: HealthSystemSetup[];
  @Output() save = new EventEmitter();
  @Input() availableRoles: string[];

  selectedHealthSystemNpis: string[] = [];
  isEditing = false;
  // showWarning = false;
  // showError = false;
  npi: string;
  errorMessage: string;
  staff: StaffDetails = new StaffDetails();

  matcher = new MyErrorStateMatcher();
  statesCodes: CodeTable;
  nameFormControl = new FormControl("", [Validators.required]);
  phoneFormControl = new FormControl("", [Validators.required]);
  faxFormControl = new FormControl("", []);
  roleFormControl = new FormControl("", [Validators.required]);
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  address1FormControl = new FormControl("", [Validators.required]);
  address2FormControl = new FormControl("", []);
  cityFormControl = new FormControl("", [Validators.required]);
  stateFormControl = new FormControl("", [Validators.required]);
  zipFormControl = new FormControl("", [Validators.required]);

  dataForm: FormGroup = new FormGroup({
    name: this.nameFormControl,
    phone: this.phoneFormControl,
    fax: this.faxFormControl,
    role: this.roleFormControl,
    email: this.emailFormControl,
    address1: this.address1FormControl,
    address2: this.address2FormControl,
    city: this.cityFormControl,
    state: this.stateFormControl,
    zip: this.zipFormControl,
  });

  constructor(
    private setupService: SetupService,
    private staffService: StaffService,
    private _matSnackBar: MatSnackBar,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.setupService.editStaff$.subscribe(
      (staff) => {
        this.isEditing = true;
        this.buildStaffObject(staff);
      },
      (error) => {
        console.error(error);
      }
    );
    this.getSates();
  }

  private destroyComponentManually() {
    this.isEditing = false;
    // this.showWarning = false;
    // this.showError = false;
    this.staff = new StaffDetails();
    this.errorMessage = "";
  }

  getSates() {
    this.commonService.GetItemsByCodeNamesWithoutCache(["STATE"]).subscribe(
      (codeTables) => {
        this.statesCodes = codeTables.codeTable[0];
      },
      (error) => console.log(error)
    );
  }

  buildStaffObject(staff: UserSetup): void {
    this.staff = new StaffDetails();
    this.staff.staffUserId = staff.id;
    this.staff.name = staff.name;
    this.staff.email = staff.email;
    this.staff.phoneNumber = staff.phoneNumber;
    this.staff.role = staff.role;
    this.staff.address = staff.address == null ? <Address>{} : staff.address;
    this.staff.healthSystemIds = staff.healthSystemIds;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onSave(): void {
    if (this.isEditing) {
      this.updateService();
    } else {
      this.saveService();
    }
  }

  private saveService(): void {
    console.log(this.staff);
    const staffReq = { StaffDetails: new Array<StaffDetails>(this.staff) };
    this.staffService.createStaff(staffReq).subscribe(
      (response) => {
        if (response.isSuccess) {
          //TODO reload the health organization component
          this.closeSidebar();
          this.save.emit();
          this.destroyComponentManually();
        } else {
          this.errorMessage = "Error: " + response.message;
        }
      },
      (error) => {
        console.error(error);
        this._matSnackBar.open(error.error.message, "Ok");
      }
    );
  }

  private updateService(): void {
    this.staffService.updateStaff(this.staff).subscribe(
      (response) => {
        if (response.isSuccess) {
          //TODO reload the health organization component
          this.closeSidebar();
          this.save.emit();
          this.destroyComponentManually();
        } else {
          this.errorMessage = "Error: " + response.message;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  closeSidebar() {
    this.destroyComponentManually();
    this.setupService.staffIsOpened = false;
  }
}
